import { render, staticRenderFns } from "./subsector.vue?vue&type=template&id=40e33e3d&scoped=true"
import script from "./subsector.vue?vue&type=script&lang=js"
export * from "./subsector.vue?vue&type=script&lang=js"
import style0 from "./subsector.vue?vue&type=style&index=0&id=40e33e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e33e3d",
  null
  
)

export default component.exports